import type { AttachmentConfig, AttachmentSlotState } from './types';

export const buildInitialAttachmentSlotStates = (
  attachments: AttachmentConfig[]
): Record<string, AttachmentSlotState> =>
  attachments.reduce<Record<string, AttachmentSlotState>>((acc, attachment) => {
    if (attachment.existingFileName) {
      acc[attachment.key] = {
        status: 'existing',
        displayName: attachment.existingFileName,
        pendingFile: null,
        originalExisting: attachment.existingFileName,
        removedExisting: false
      };
      return acc;
    }

    if (attachment.removedExistingFileName) {
      acc[attachment.key] = {
        status: 'empty',
        displayName: '',
        pendingFile: null,
        originalExisting: attachment.removedExistingFileName,
        removedExisting: true
      };
      return acc;
    }

    acc[attachment.key] = {
      status: 'empty',
      displayName: '',
      pendingFile: null,
      originalExisting: null,
      removedExisting: false
    };

    return acc;
  }, {});
